import {
  Invoice,
  typeGuardSelectedInvoice,
} from '@/components/ReportForm/ApReportFormInputInvoiceFileField/type';
import { FilePreview } from '@/features/InvoiceReport/Edit/components/Drawer/OcrReflectionDrawer/Components/Preview/FilePreview';
import { SelectedInvoicePreview } from '@/features/InvoiceReport/Edit/components/Drawer/OcrReflectionDrawer/Components/Preview/SelectedInvoicePreview';
import { FC, memo } from 'react';

export type Props = {
  invoice: Invoice;
};

export const Preview: FC<Props> = memo(({ invoice }) => {
  if (!invoice) {
    return null;
  }

  return typeGuardSelectedInvoice(invoice) ? (
    <SelectedInvoicePreview invoice={invoice} />
  ) : (
    <FilePreview invoice={invoice} />
  );
});
Preview.displayName = 'Preview';
